import { render, staticRenderFns } from "./BannerContentSelect.vue?vue&type=template&id=b5b33544&"
import script from "./BannerContentSelect.vue?vue&type=script&lang=js&"
export * from "./BannerContentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b33544')) {
      api.createRecord('b5b33544', component.options)
    } else {
      api.reload('b5b33544', component.options)
    }
    module.hot.accept("./BannerContentSelect.vue?vue&type=template&id=b5b33544&", function () {
      api.rerender('b5b33544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/banner-manage/BannerContentSelect.vue"
export default component.exports